import React, { Component, Fragment } from 'react'
import { IconButton, Typography, DialogContent, Dialog, DialogTitle, List, ListItem, ListItemText, ListItemSecondaryAction, Button, FormControlLabel, Radio } from '@material-ui/core';
import AddFieldForm from './FormCreator/AddFieldForm';
import Form from "react-jsonschema-form";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import IconDelete from '@material-ui/icons/Delete'
import IconEdit from '@material-ui/icons/Edit';
import IconReorder from '@material-ui/icons/Reorder';
import { initial, template1, template2, template3 } from './FormCreator/Templates';

class FormCreator extends Component {

    state = {
        //schema
        fieldToEdit: '',
        title: "Form title",
        description: "Form description",
        type: "object",
        required: [],
        properties: {},
        uiSchema: {},
        //internal
        addFieldDialog: false,
        isTemplate: true
    }

    componentDidMount() {
        let template = this.jsonCopy(template1);
        this.setState({ ...template });
    }

    toggleAddFieldDialog = () => {
        this.setState(prevState => ({
            addFieldDialog: !prevState.addFieldDialog
        }));
    }

    jsonCopy = (src) => {
        return JSON.parse(JSON.stringify(src));
    }

    resetFieldToEdit = () => {
        this.setState({ fieldToEdit: '' });
    }

    setValue = (key, e) => {
        const schema = this.state;
        const value = e.target.value;
        schema[key] = value;
        this.setState(...schema, { key: value });
    }

    handleDelete = (id) => {
        let { properties, required, uiSchema } = this.state;
        delete properties[id];
        if (required.includes(id)) {
            required = required.filter(element => element !== id);
        }
        if (uiSchema[id]) {
            delete uiSchema[id]
        }
        this.setState({ properties, required, uiSchema });
    }

    handleEdit = (fieldToEdit) => {
        this.setState({ fieldToEdit }, () => {
            this.toggleAddFieldDialog();
        });
    }

    onAdd = (values) => {
        const { isRequired, id, rows, options, enumType, maximum, minimum, type } = values;
        let { required, properties, uiSchema } = this.state;

        if (rows > 1) {
            uiSchema[id] = {
                "ui:widget": "textarea",
                "ui:options": {
                    rows: Number(rows)
                }
            }
        }

        if (options && options.length > 0 && enumType === 'radio') {
            uiSchema[id] = {
                "ui:widget": enumType,
                "ui:options": {
                    inline: false
                }
            }
        }

        if (type === 'integer') {
            if (!maximum) {
                delete values['maximum'];
            }
            if (!minimum) {
                delete values['minimum'];
            }
        }

        if (isRequired) {
            required.push(id);
        }
        properties[id] = {
            ...values,
            enum: options,
            default: '',
        }
        this.setState({ properties, required, uiSchema }, () => {
            console.warn(this.state)
            this.toggleAddFieldDialog();
        });

    }

    onUpdate = (field) => {
        let { properties } = this.state;
        properties[field.id] = {
            ...properties[field.id],
            ...field
        }
        this.setState({ properties }, () => {
            this.toggleAddFieldDialog();
        });
    }

    getFieldType = (type) => {
        switch (type) {
            case 'string':
                return 'Text'
            case 'integer':
                return 'Number'
            case 'textarea':
                return 'Multiline text'
            case 'select':
                return 'Drop down'
            default:
                return type;
        }
    }

    templateToggler = (e) => {
        const value = e.target.value;
        let isTemplate = true;
        let template;
        switch (value) {
            case 'custom':
                template = this.jsonCopy(initial);
                isTemplate = false;
                break;
            case 'template1':
                template = this.jsonCopy(template1);
                break;
            case 'template2':
                template = this.jsonCopy(template2);
                break;
            case 'template3':
                template = this.jsonCopy(template3);
                break;
            default:
                break;
        }
        this.setState({ isTemplate, ...template });
    }

    render() {
        const { handleNext } = this.props;
        const { addFieldDialog, fieldToEdit, isTemplate } = this.state;
        const properties = Object.values(this.state.properties);

        return (
            <div className='creator-container'>
                <div className='creator-item'>
                    <Typography style={{ fontWeight: 600 }}>Builder</Typography>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <fieldset id='root'>
                            <div className='form-group field'>
                                <label>Template</label>
                                <select
                                    onChange={this.templateToggler}
                                    name='type'
                                    className="form-control"
                                >
                                    <option value='template1'>Template #1</option>
                                    <option value='template2'>Template #2</option>
                                    <option value='template3'>Template #3</option>
                                    <option value='custom'>Custom</option>
                                </select>
                            </div>
                            <div className='form-group field field-string'>
                                <label className='control-label' htmlFor='builder-title'>
                                    Form Title
                                </label>
                                <input onChange={(e) => this.setValue('title', e)} className="form-control" id="builder-title" label="Form Title" placeholder="" value={this.state.title} type="text" />
                            </div>
                            <div className='form-group field field-string'>
                                <label className='control-label' htmlFor='builder-title'>
                                    Form Description
                                </label>
                                <input onChange={(e) => this.setValue('description', e)} className="form-control" id="builder-title" label="Form Title" placeholder="" value={this.state.description} type="text" />
                            </div>
                        </fieldset>
                        {
                                            !isTemplate && (
                        <Fragment>
                        <Typography style={{ fontWeight: 600, textAlign: 'center' }}>Fields</Typography>
                        <List style={{ maxHeight: 400, overflow: 'auto', margin: '10px 0' }}>
                            {
                                properties.map((field, index) => (
                                    <ListItem
                                        key={index}
                                        divider={index !== properties.length - 1}
                                        style={{ paddingTop: 0, paddingBottom: 0 }}
                                    >
                                        <ListItemText
                                            secondaryTypographyProps={{ style: { textTransform: 'capitalize' } }}
                                            primary={field.title}
                                            secondary={this.getFieldType(field.origType)}
                                        />
                                     
                                                <ListItemSecondaryAction>
                                                    <IconButton onClick={() => this.handleDelete(field.id)}>
                                                        <IconDelete style={{ fontSize: 16 }} />
                                                    </IconButton>
                                                    <IconButton onClick={() => this.handleEdit(field)}>
                                                        <IconEdit style={{ fontSize: 16 }} />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                      
                                    </ListItem>
                                ))
                            }
                        </List>
                        <Button
                            onClick={this.toggleAddFieldDialog}
                            variant="outlined"
                            color='primary'
                            fullWidth
                            disabled={isTemplate}
                        >
                            Add Field
                        </Button>
                        </Fragment>
                        )
                    }
                    </div>
                </div>
                <div className='creator-item'>
                    <Typography style={{ fontWeight: 600 }}>Preview</Typography>
                    <div style={{ overflow: 'auto', width: '100%', flexGrow: 1, padding: '0 15px' }}>
                        <Form
                            schema={this.state}
                            uiSchema={this.state.uiSchema}
                        />
                    </div>
                    <div style={{ width: '100%', textAlign: 'end' }}>
                        <Button
                            onClick={() => handleNext(this.state)}
                            variant="contained"
                            color='primary'
                            fullWidth
                        >
                            Next
                    </Button>
                    </div>
                </div>
                <Dialog
                    open={addFieldDialog}
                    onClose={this.toggleAddFieldDialog}
                >
                    <DialogTitle>
                        Add Field
                    </DialogTitle>
                    <DialogContent>
                        <AddFieldForm
                            onAdd={this.onAdd}
                            fieldToEdit={fieldToEdit}
                            resetFieldToEdit={this.resetFieldToEdit}
                            onUpdate={this.onUpdate}
                        />
                    </DialogContent>
                </Dialog>
            </div>
        )

    }
}

export default FormCreator;



// WEBPACK FOOTER //
// ./src/containers/widget/components/Steps/FormCreator.js